import { Component, ViewEncapsulation } from '@angular/core';

/** Content-only theme wrapper. Empower owns the header and navigation. */
@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent {}
